/* tslint:disable */
/* eslint-disable */
/**
 * Bookingkit Api v4
 * Specification of Bookingkit Api v4
 *
 * The version of the OpenAPI document: 0.19.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export const PaymentProviderIdEnum = {
    Stripe: 'STRIPE',
    Mangopay: 'MANGOPAY'
};
export const PaymentProviderStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Scheduled: 'SCHEDULED'
};
export const PaymentProviderKycStatusEnum = {
    Verified: 'VERIFIED',
    Unverified: 'UNVERIFIED',
    Pending: 'PENDING',
    ActionRequired: 'ACTION_REQUIRED',
    Rejected: 'REJECTED'
};
